import React, { type HTMLAttributes, type ReactElement } from "react";
import { DevicesThemeListItem } from "@/components";
import { ThemeLegend } from "@/types";

interface DevicesThemeListProps extends HTMLAttributes<HTMLUListElement> {
  themes: ThemeLegend[];
}

function DevicesThemeList({
  themes,
}: Readonly<DevicesThemeListProps>): ReactElement {
  return (
    <ul className="list-none flex flex-col gap-1">
      {themes.map((theme): ReactElement => {
        return (
          <DevicesThemeListItem
            count={theme.count}
            key={theme.type}
            label={theme.label}
            type={theme.type}
          />
        );
      })}
    </ul>
  );
}

export { DevicesThemeList, type DevicesThemeListProps };
